import TripFormContainer from './TripFormContainer';

export default TripFormContainer;
